import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-statistic-chart tooltip-graph" }
const _hoisted_2 = { class: "top-statistic-chart__body" }
const _hoisted_3 = { class: "top-statistic-chart__header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EChartsHorizontalBar = _resolveComponent("EChartsHorizontalBar")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title", {}, undefined, true)
      ]),
      _createVNode(_component_EChartsHorizontalBar, {
        labels: _ctx.chartLabels,
        dataset: _ctx.chartDataset,
        showLegend: "",
        height: _ctx.chartHeight,
        isLoading: _ctx.isLoading,
        emptyMessage: "Нет данных",
        valueFractionDigits: 0,
        xAxisMaxRatio: 1.2,
        categoryLabelWidth: 280,
        minWidth: 600,
        class: "top-statistic-chart__chart",
        onClickedBar: _ctx.onClickedBar
      }, null, 8, ["labels", "dataset", "height", "isLoading", "onClickedBar"])
    ])
  ]))
}